import React, { useState } from "react";
import { put } from "../../api";
import Modal from "../Modal";
import Button from "../Button";
import Space from "../Space";
import OrientationOptions from "../OrientationOptions";
import { getXYZ } from "../../helpers/orientation";
import Label from "../../components/Label";
import SliderCustom from '../../components/SliderCustom';
import styles from './InstallDeviceStep2.module.scss';
export default function InstallDeviceStep2({ selectedAsset, back, next ,step=false,skipSave=false,passThresholds}) {
  const [selected, setSelected] = useState("POSITION_FLAT");
  const [sensitivity, setSensitivity] = useState(2);

  async function saveAndNext() {
    const thresholds = getXYZ(selected, sensitivity);
    if (selectedAsset != null) {
      if (selectedAsset?.id != 0) {
        await put(`/assets/${selectedAsset.id}`, {
          ...selectedAsset,
          ...thresholds
        });
      } else {
        passThresholds(thresholds);
      }
    } else {
      passThresholds(thresholds);
    }
    next();
  }

  function _renderFooter() {
    return (
      <div className={styles.ontop}>
        {back && <Button  onClick={back}>Back</Button>}
        <Button theme="primary" onClick={saveAndNext}>
          Next
        </Button>
      </div>
    );
  }

  return (
    <Modal  onTop={true} footer={_renderFooter()}>
      <Space size="m">
        <h2>Step {step==false ? 4 : 3}: Install the device</h2>
      </Space>
      <Space size="m">
        <p>
          Next, install the device on the asset according to the Mounting
          Options provided on the Sentinel Web Site.
        </p>
      </Space>
      <Space size="l">
        <OrientationOptions selected={selected} setSelected={setSelected} />
      </Space>
      <Label text="Sensitivity">
        <SliderCustom
          inputValue={sensitivity}
          onChangeAction={(e, v) => { setSensitivity(v) }}
        />
      </Label>
    </Modal>
  );
}
